import { IAction } from '@Root/types'

export const OnboardingActionTypes = {
  FETCH_QUICKSTART_SETTINGS: '@@onboarding/FETCH_QUICKSTART_SETTINGS',
  FETCH_QUICKSTART_SETTINGS_SUCCESS: '@@onboarding/FETCH_QUICKSTART_SETTINGS_SUCCESS',
  FETCH_QUICKSTART_SETTINGS_FAILURE: '@@onboarding/FETCH_QUICKSTART_SETTINGS_FAILURE',
  START_QUICKSTART_PROCESSING: '@@onboarding/START_QUICKSTART_PROCESSING',
  START_QUICKSTART_PROCESSING_SUCCESS: '@@onboarding/START_QUICKSTART_PROCESSING_SUCCESS',
  START_QUICKSTART_PROCESSING_FAILURE: '@@onboarding/START_QUICKSTART_PROCESSING_FAILURE',
  FINISH_SURVEY: '@@onboarding/FINISH_SURVEY',
  FINISH_SURVEY_SUCCESS: '@@onboarding/FINISH_SURVEY_SUCCESS',
  FINISH_SURVEY_FAILURE: '@@onboarding/FINISH_SURVEY_FAILURE',
  GET_FORWARDING_PATH: '@@onboarding/GET_FORWARDING_PATH',
}

export interface IFetchQuickstartSettingsSuccessResponseBody {
  readonly availableLanguages: {
    readonly attributes: {
      readonly languagesForVideos: string[]
      readonly translationLanguages: string[]
      readonly dubbingLanguages: string[]
      readonly voiceCloningLanguages: string[]
    }
  }
}

export interface IStartQuickstartProcessingPayload {
  readonly workspaceId: number
  readonly projectVersionLanguage: string
  readonly translationLanguage: string
  readonly dubbing: boolean
  readonly voiceCloning: boolean
  readonly repurposing: boolean
  readonly projectVersionId?: string
  readonly selectedSample?: string
  readonly videoUrl?: string
}

export interface IGetForwardingPathSuccessResponseBody {
  readonly forwardingPath?: string
}

export type TOnboardingActionTypes =
  IAction<IFetchQuickstartSettingsSuccessResponseBody> |
  IAction<IStartQuickstartProcessingPayload>
